import {
  DEFAULT_UI_LANGUAGE,
  UI_LANGUAGE_SHORT_CODE_MAP,
} from 'admin-panel/constants';
import type { DashboardMetricFormat } from 'admin-panel/types/dashboard';

export function formatDashboardMetricValue(
  value: number | undefined,
  format: DashboardMetricFormat,
  locale: string,
  currencyCode?: string
) {
  const safeValue = value ?? 0;

  switch (format) {
    case 'currency':
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode || 'EUR',
        maximumFractionDigits: 0,
      }).format(safeValue);
    case 'duration':
      return formatDuration(safeValue, locale);
    case 'number':
      return new Intl.NumberFormat(locale).format(safeValue);
  }
}

export function formatDuration(
  totalSeconds: number,
  locale: string,
  unitDisplay: 'narrow' | 'short' = 'narrow'
) {
  const seconds = Math.max(0, Math.round(totalSeconds));
  const unit = (name: 'minute' | 'second', amount: number) =>
    new Intl.NumberFormat(locale, {
      style: 'unit',
      unit: name,
      unitDisplay,
    }).format(amount);

  return `${unit('minute', Math.floor(seconds / 60))} ${unit(
    'second',
    seconds % 60
  )}`;
}

export function localeKeyToIntlLocale(localeKey?: string) {
  return (
    UI_LANGUAGE_SHORT_CODE_MAP[
      localeKey as keyof typeof UI_LANGUAGE_SHORT_CODE_MAP
    ] ?? DEFAULT_UI_LANGUAGE
  );
}
